@if (pageReady) {
    <div class="overview">
        <cerrix-select-tree
            [tree]="standingData.frameworks"
            [value]="selectedFrameworkIDs"
            [multiselect]="true"
            (onChangeIds)="applyFrameworkChanges($event, frameworkSelectTree)"
            style="display: none"
            #frameworkSelectTree
        ></cerrix-select-tree>

        <div class="items">
            <div class="detail-page-card">
                <div class="detail-page-card-title">{{ 'fieldworkPlan.fieldworkStepsTitle' | t }}</div>
                @if (
                    permissions.fieldworkPermissions.canCreate ||
                    permissions.fieldworkPermissions.canDelete
                ) {
                    <div class="detail-page-card-actions">
                        <button
                            class="btn btn-raised"
                            data-uiid="fieldwork-plan-add-framework-step-button"
                            (click)="frameworkSelectTree.openSelectionPopup()"
                        >
                            <i class="fas fa-sitemap me-2"></i>{{ 'fieldworkPlan.frameworkSelectionButton' | t }}
                        </button>
                        <div class="spacer"></div>
                        @if (permissions.fieldworkPermissions.canCreate) {
                            <button
                                class="btn btn-raised"
                                data-uiid="fieldwork-plan-add-custom-step-button"
                                (click)="addCustomStep()"
                            >
                                <i class="fas fa-plus me-2"></i>{{ 'fieldworkPlan.addCustomStepButton' | t }}
                            </button>
                        }
                    </div>
                }
                @if (treeViewerConfig) {
                    <div class="detail-page-card-body">
                        <cerrix-tree-viewer [config]="treeViewerConfig"></cerrix-tree-viewer>
                    </div>
                }
            </div>
        </div>

        <div class="detail">
            <div class="edit-area">
                @if (selectedFormGroup) {
                    <div class="edit-details">
                        <div class="detail-page-action-bar">
                            <span class="sub-message">
                                @if (selectedStepIsFrameworkStep) {
                                    Framework step linked to '{{ selectedStep.frameworkName }}'
                                } @else {
                                    {{ 'fieldworkPlan.customStep' | t }}
                                }
                            </span>

                            <div class="right-area">
                                @if (permissions.fieldworkPermissions.canDelete) {
                                    <button
                                        class="btn btn-danger btn-sm"
                                        (click)="removeStep(selectedStep.id)"
                                    >
                                        <i class="fal fa-trash"></i>
                                        <span class="d-none d-lg-inline">{{ 'fieldworkPlan.removeButton' | t }}</span>
                                    </button>
                                }
                            </div>
                        </div>

                        <form [formGroup]="selectedFormGroup">
                            <div class="detail-page-card">
                                <div class="detail-page-card-title">
                                    <span>{{ 'fieldworkPlan.stepDetailsTitle' | t }}</span>
                                </div>
                                <div class="detail-page-card-body padded">
                                    <div class="row">
                                        <div class="col-6">
                                            <cerrix-textfield
                                                [fieldLabel]="'fieldworkPlan.nameLabel' | t"
                                                formControlName="name"
                                            ></cerrix-textfield>
                                            <div class="form-group col cerrix-textfield">
                                                <label>{{ 'fieldworkPlan.iconLabel' | t }}</label>
                                                @if (selectedStep) {
                                                    <cerrix-icon-picker
                                                        formControlName="icon"
                                                        [value]="selectedStep.icon"
                                                    ></cerrix-icon-picker>
                                                }
                                            </div>
                                        </div>
                                        <div class="col-6">
                                            <div class="form-group col cerrix-textfield">
                                                <label>{{ 'fieldworkPlan.auditorsLabel' | t }}</label>
                                                <ng-select
                                                    id="auditorSelect"
                                                    name="auditorSelect"
                                                    [multiple]="true"
                                                    [items]="auditors"
                                                    placeholder="{{
                                                        selectedStep.useReviewWorkflow
                                                            ? ('main.requiredPlaceholder' | t)
                                                            : ''
                                                    }}"
                                                    formControlName="auditors"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [closeOnSelect]="false"
                                                >
                                                </ng-select>
                                            </div>

                                            <div class="form-group col cerrix-textfield">
                                                <label>{{ 'fieldworkPlan.reviewersLabel' | t }}</label>
                                                <ng-select
                                                    id="reviewerSelect"
                                                    name="reviewerSelect"
                                                    [multiple]="true"
                                                    [items]="reviewers"
                                                    placeholder="{{
                                                        selectedStep.useReviewWorkflow
                                                            ? ('main.requiredPlaceholder' | t)
                                                            : ''
                                                    }}"
                                                    formControlName="reviewers"
                                                    bindLabel="Name"
                                                    bindValue="ID"
                                                    [closeOnSelect]="false"
                                                >
                                                </ng-select>
                                            </div>
                                            <div class="boolswitch detail-page-card-title">
                                                <mat-slide-toggle
                                                    name="boolvalue"
                                                    formControlName="useReviewWorkflow"
                                                    (change)="useReviewWorkflowChanged($event)"
                                                    size="small"
                                                    color="primary"
                                                    data-uiid="audit-detail-fieldwork-plan-use-review-workflow"
                                                >
                                                    {{ 'fieldworkPlan.useReviewWorkflow' | t }}
                                                </mat-slide-toggle>
                                            </div>
                                        </div>
                                    </div>

                                    <cerrix-textarea
                                        [fieldLabel]="'fieldworkPlan.descriptionLabel' | t"
                                        formControlName="description"
                                    ></cerrix-textarea>
                                </div>
                            </div>

                            <div class="detail-page-card">
                                <div class="detail-page-card-title">
                                    <span>{{ 'fieldworkPlan.executionWorkingMethodTitle' | t }}</span>
                                </div>
                                <div class="detail-page-card-actions">
                                    <audit-detail-fieldwork-execution-detail-manager
                                        [steps]="steps"
                                        [canEdit]="permissions.fieldworkPermissions.canEdit"
                                        (onChange)="setSelectedStepExecutionDetails()"
                                    >
                                    </audit-detail-fieldwork-execution-detail-manager>
                                </div>
                                <div class="detail-page-card-body padded">
                                    @if (selectedStepExecutionDetails) {
                                        @for (
                                            item of selectedStepExecutionDetails | keyvalue;
                                            track item
                                        ) {
                                            <div class="form-group col cerrix-textfield">
                                                <label>{{ item.key }}</label>
                                                <textarea
                                                    autogrow
                                                    class="form-control form-control-sm"
                                                    readonly
                                                    [value]="item.value"
                                                >
                                                </textarea>
                                            </div>
                                        }
                                    } @else {
                                        <span>{{ 'fieldworkPlan.noExecutionWorkingMethod' | t }}</span>
                                    }
                                </div>
                            </div>
                        </form>
                    </div>
                } @else {
                    <div class="no-selection-message">
                        <span>{{ 'fieldworkPlan.selectStepToConfigure' | t }}</span>
                    </div>
                }
            </div>
        </div>
    </div>
} @else {
    <div class="fancy-loader"></div>
}
